import { render, staticRenderFns } from "./ImgText.vue?vue&type=template&id=323da2ce&scoped=true"
import script from "./ImgText.vue?vue&type=script&lang=js"
export * from "./ImgText.vue?vue&type=script&lang=js"
import style0 from "./ImgText.vue?vue&type=style&index=0&id=323da2ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323da2ce",
  null
  
)

export default component.exports